import React from "react"
import {
    MdOutlineSchool,
    MdOutlineWorkOutline,
    MdOutlinePerson,
    MdOutlineMedicalServices,
} from "react-icons/md"
import Card from "../../controls/Card"
import { EApplicationUserStatusBg, GetEApplicationUserStatusName } from "../../../configurations/enums/EApplicationUserStatus"
import StatusContainer from "../../controls/StatusContainer"
import { GetEGenderName } from "../../../configurations/enums/EGender"
import Dp from "./Dp"

export default function User({
    user,
    title,
    isBorder,
    borderColor = "border-gray-400",
    isBack = false,
    subTitle,
    isRefresh = false,
    doRefresh,
}) {
    return (
        <Card
            borderColor={borderColor}
            isBack={isBack}
            title={title}
            isBorder={isBorder}
            subTitle={subTitle}
            isRefresh={isRefresh}
            doRefresh={doRefresh}
        >
            <div className="flex flex-col items-center px-2 py-3 text-center">

                {/* Avatar */}
                <Dp
                    user={user}
                    height="h-28 sm:h-32 lg:h-36"
                    width="w-28 sm:w-32 lg:w-36"
                />

                {/* Name */}
                <h1 className="mt-3 text-lg font-bold leading-7 text-gray-900">
                    Dr. {user?.fullName}
                </h1>

                {/* Specialisation */}
                {user?.specialisation?.name && (
                    <span className="mt-2 inline-flex max-w-full items-center gap-1.5 rounded-full bg-brand-50 px-3 py-1 text-xs font-semibold text-brand-700">
                        <MdOutlineMedicalServices className="shrink-0 text-sm" />
                        <span className="truncate">
                            {user.specialisation.name}
                            {user.specialisation.shortName ? ` (${user.specialisation.shortName})` : ""}
                        </span>
                    </span>
                )}

                {/* Divider */}
                <div className="my-2 h-px w-12 bg-gray-200" />

                {/* Details — same icon-row language as the OPD center cards */}
                <dl className="w-full space-y-2.5 text-left">
                    {user?.degree && (
                        <Detail icon={<MdOutlineSchool />} label="Degree" value={user.degree} />
                    )}
                    {(user?.experiance ?? user?.experience) != null && (
                        <Detail
                            icon={<MdOutlineWorkOutline />}
                            label="Experience"
                            value={`${user.experiance ?? user.experience} years`}
                        />
                    )}
                    {/* {user?.gender != null && (
                        <Detail
                            icon={<MdOutlinePerson />}
                            label="Gender"
                            value={GetEGenderName(user.gender)}
                        />
                    )} */}
                </dl>
            </div>
        </Card>
    )
}

function Detail({ icon, label, value }) {
    return (
        <div className="flex items-center gap-2.5">
            <span className="grid h-7 w-7 shrink-0 place-items-center rounded-lg bg-gray-50 text-base text-gray-400">
                {icon}
            </span>
            <div className="flex min-w-0 flex-col">
                <span className="text-[11px] font-medium uppercase tracking-wide text-gray-400">
                    {label}
                </span>
                <span className="truncate text-sm font-medium text-gray-700">{value}</span>
            </div>
        </div>
    )
}